import React, { useEffect } from 'react'
import Heading from '../components/Heading'
import ResponsiveTable from '../components/ResponsiveTable'
import ModuleWithLoader from '../components/ModuleWithLoader'
import PlainText from '../components/PlainText'

const RateCardTelstra = () => {
    const data = require('../../data/mobile/telstraRateCard.json')

    return (
        <div className='rate-card module'>
            <Heading title='My rate card' />
            <ModuleWithLoader isLoaded className='p-4'>
                <div className='row mb-4'>
                    <div className='col-12 col-md-8 offset-md-2 text-center'>
                        <h2 className='m-0 mt-1'>Check out charges and inclusions across plans</h2>
                        <p>Exetel pre-paid SIM-only mobile plans have varying data and some include unlimited international call and standard text in their 30 day allowances. Everything else is standard across all plans</p>
                    </div>
                </div>
                <div className='row mb-4'>
                    <div className='col-12'>
                        <h4 className='mt-0 bold text-center'>Variable charges and inclusions by plan</h4>
                        {data.differentCharges.map((item, key) => {
                            return <PlainText key={key} data={item} excludeTitle className='add-margin' minWidthMobile={700} />
                        })}
                    </div>
                </div>
                <div className='row'>
                    <div className='col-12'>
                        <h4 className='mt-0 bold text-center'>Charges and inclusions for all plans</h4>
                        {data.allCharges.map((item, key) => {
                            return <PlainText key={key} data={item} excludeTitle className='add-margin' minWidthMobile={600} />
                        })}
                    </div>
                </div>

            </ModuleWithLoader>
        </div>
    )
}

export default RateCardTelstra



// WEBPACK FOOTER //
// ./resources/js/modules/RateCardTelstra.js